// extracted by mini-css-extract-plugin
export default {"formBlock":"Form_formBlock__7mzR6","form":"Form_form__r2bEM","inputSet":"Form_inputSet__xN4jG"};